// extracted by mini-css-extract-plugin
export var dropdownButton = "_2p-0";
export var fullWidthDropdownButton = "_2p-1";
export var icon = "_2p-3";
export var iconPlaceholder = "_2p-2";
export var menuItemRow = "_2p-9";
export var separator = "_2p-e";
export var shortcutContainer = "_2p-7";
export var shortcutContainerFilled = "_2p-8";
export var shortcutIconLg = "_2p-6";
export var shortcutIconMd = "_2p-5";
export var shortcutIconSm = "_2p-4";
export var submenuChevron = "_2p-d";
export var submenuDropdown = "_2p-a";
export var submenuTriggerRow = "_2p-b";
export var submenuTriggerRowOpen = "_2p-c";